import { render } from "./PageAfterSignup.vue?vue&type=template&id=1f28cf03"
import script from "./PageAfterSignup.vue?vue&type=script&lang=js"
export * from "./PageAfterSignup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__